import { render, staticRenderFns } from "./DriverLayout.vue?vue&type=template&id=e6544686&scoped=true&"
import script from "./DriverLayout.vue?vue&type=script&lang=js&"
export * from "./DriverLayout.vue?vue&type=script&lang=js&"
import style0 from "./DriverLayout.vue?vue&type=style&index=0&id=e6544686&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6544686",
  null
  
)

component.options.__file = "DriverLayout.vue"
export default component.exports